import {
  LocalizationAvailableLangType,
  MenuItemType,
  MenuItemTagType,
  MenuChildrenItemType,
} from "@/schemas/index";
import env from "@/app/config/env";

const filteredMenuItems = (
  items: MenuItemType[],
  tags: MenuItemTagType[],
): MenuItemType[] => {
  return items.filter((item: MenuItemType) => {
    if (item.children) {
      item.children = filteredMenuItems(
        item.children,
        tags,
      ) as MenuChildrenItemType[];

      if (!item.children.length && item.href) {
        item.children = undefined;
        return (
          !item?.tags?.length ||
          tags.every((tag: MenuItemTagType) =>
            (item as MenuChildrenItemType).tags.includes(tag),
          )
        );
      }

      return item.children.length > 0;
    }

    return (
      !item?.tags?.length ||
      tags.every((tag: MenuItemTagType) =>
        (item as MenuChildrenItemType).tags.includes(tag),
      )
    );
  });
};

const getMenuItems = (
  currentLang: LocalizationAvailableLangType,
  jwtToken?: string,
): MenuItemType[] =>
  [
    {
      id: "user.profile",
      text: "Edit",
      tags: ["user"],
      iconKey: "user-edit",
      href: `/${currentLang}/profile`,
    },
    {
      id: "support.logout",
      text: "Logout",
      tags: ["user"],
      iconKey: "log-out",
    },
    {
      id: "company",
      children: [
        {
          id: "company.accounts",
          text: "Accounts",
          tags: ["header", "footer"],
          iconKey: "accounts",
          href: `/${currentLang}/accounts`,
        },
        {
          id: "company.business.units",
          text: "Business Units",
          tags: ["header", "footer"],
          iconKey: "business-units",
          href: `/${currentLang}/businessunits`,
        },
        {
          id: "company.employees",
          text: "Employees",
          tags: ["header", "footer"],
          iconKey: "employees",
          href: `/${currentLang}/employees`,
        },
      ],
    },
    {
      id: "products",
      children: [
        {
          id: "products.subscriptions",
          text: "Subscriptions",
          tags: ["header", "footer"],
          iconKey: "subscriptions",
          href: `/${currentLang}/subscriptions`,
        },
        {
          id: "products.hardware",
          text: "Hardware",
          tags: ["header", "footer"],
          iconKey: "hardware",
          href: `/${currentLang}/hardware`,
        },
        {
          id: "products.delivery",
          text: "Delivery Status",
          tags: ["header", "footer"],
          iconKey: "delivery",
          href: `/${currentLang}/delivery`,
        },
        // {
        //   id: "products.quotes",
        //   text: "Quotes",
        //   tags: ["header"],
        //   iconKey: "quotes",
        //   href: `/${currentLang}/store/offers`,
        // },
      ],
    },
    {
      id: "marketplace",
      text: "Marketplace",
      href: `/${currentLang}/store`,
      tags: ["header", "footer", "guest"],
      children: [
        {
          id: "store",
          text: "Store",
          tags: ["footer"],
          href: `/${currentLang}/store`,
        },
        // {
        //   id: `quotes`,
        //   text: "Quotes",
        //   tags: ["footer"],
        //   href: `https://my.petrosoftinc.com/${currentLang}/store/offers`
        // }
      ],
    },
    {
      id: "billing",
      text: "Billing",
      children: [
        {
          id: "billing.orders",
          text: "Orders",
          tags: ["header"],
          iconKey: "orders",
          href: `/${currentLang}/billing/orders`,
        },
        {
          id: "billing.invoices",
          text: "Invoices",
          tags: ["header"],
          iconKey: "invoices",
          href: `/${currentLang}/billing/invoices`,
        },
        {
          id: "billing.payment.methods",
          text: "Payment Methods",
          tags: ["header"],
          iconKey: "payment-methods",
          href: `/${currentLang}/billing/paymentmethods`,
        },
      ],
    },
    {
      id: "service",
      children: [
        {
          id: "service.create.request",
          text: "New Service Request",
          tags: ["header"],
          iconKey: "add-new",
          href: `/${currentLang}/service/requests/create`,
        },
        {
          id: "service.service.appointments",
          text: "Service Appointments",
          tags: ["header"],
          iconKey: "service-appoyntment",
          href: `/${currentLang}/service/requests`,
        },
      ],
    },
    {
      id: "support",
      children: [
        {
          id: "support.center",
          text: "Support Center",
          tags: ["header", "guest", "footer"],
          iconKey: "support-center",
          href: `/${currentLang}/support`,
        },
        {
          id: "support.knowledge.base",
          text: "Knowledge Base",
          tags: ["header", "guest", "footer"],
          iconKey: "knowledge-base",
          href: `/${currentLang}/support/kb`,
        },
        {
          id: "petrosoft.university",
          text: "Petrosoft University",
          tags: ["header", "guest"],
          iconKey: "university",
          target: "_blank",
          href: `${env.hosts.help}`,
        },
        {
          id: "support.faq",
          text: "FAQ",
          tags: ["header", "guest"],
          iconKey: "faq",
          href: `/${currentLang}/support/faq`,
        },
        {
          id: "support.requests",
          text: "Support Requests",
          tags: ["header"],
          iconKey: "support",
          href: `/${currentLang}/support/cases`,
        },
        {
          id: "support.create",
          text: "New Support Request",
          tags: ["header"],
          iconKey: "add-new",
          target: "_blank",
          href: `${
            env.hosts.reports
          }/external/access/support/create/session/?token=${jwtToken}`,
        },
      ],
    },
  ] as MenuItemType[];

export const fetchMockupMenuItems = (
  currentLang: LocalizationAvailableLangType,
  tags: MenuItemTagType[],
  jwtToken?: string,
): MenuItemType[] => {
  return filteredMenuItems(getMenuItems(currentLang, jwtToken), tags);
};
